module.exports = __webpack_public_path__ + "assets/img/0806.6b82f627.png";